import { render, staticRenderFns } from "./PageFeed.pug?vue&type=template&id=6fa5deda&scoped=true&lang=pug&"
import script from "./PageFeed.vue?vue&type=script&lang=ts&"
export * from "./PageFeed.vue?vue&type=script&lang=ts&"
import style0 from "./PageFeed.vue?vue&type=style&index=0&id=6fa5deda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5deda",
  null
  
)

export default component.exports